
import { JsonNeedPost } from 'app/com/ibm/tw/commons/annotation/jackson';
import { E2eBean } from 'app/com/ibm/tw/commons/beans/e2e.bean';
import { LoginStateType } from 'app/com/ibm/tw/commons/enums/area/common/login.state.type';
import { B2cTxViewForm } from 'app/com/ibm/tw/commons/mvc/b2c.tx.viewform';
import { Combo } from 'ui-components/common';

export class CcmotlgacHomeViewForm extends B2cTxViewForm {

    @JsonNeedPost()
    accessToken: string;

    /** 轉導網址 */
    redirectUrl: string;

    /** 是否轉導 */
    redirect: boolean;

    webVersion: string;

    /** 所屬地區 */
    @JsonNeedPost()
    areaType: string;

    @JsonNeedPost()
    loginIxd: string;

    @JsonNeedPost()
    loginUserIxd: string;

    @JsonNeedPost()
    loginPin: string;

    loginPinValue: string;

    @JsonNeedPost()
    loginPinLength: string;

    /** 使用者目前的語系 */
    @JsonNeedPost()
    selectedLocale: string;

    @JsonNeedPost()
    illegalPin: boolean = false;

    /** 是否E2E旗標 */
    e2eBean: E2eBean;

    /** 顧客ID的最大長度 */
    loginIxdMaxLength: number;

    /** 使用者名稱的最大長度 */
    loginUserIxdMaxLength: number;

    @JsonNeedPost()
    captchaAnswer: string;

    /** 國別選單 */
    countryCombo: Combo;

    /** 多國語系選項 */
    language: Combo;
    selectLanguage: string;

    /** 人員登入狀態 */
    loginStateType: LoginStateType = LoginStateType.UNKNOWN;

    /** 產生Captcha 的Server  */
    serverUrl: string;

    /** loginIxd欄位的錯誤訊息 */
    loginIxdMessage: string = '';
    displayLoginIxdMessage: boolean = false;

    /** loginUserIx 欄位的錯誤訊息 */
    loginUserIxdMessage: string = '';
    displayLoginUserIxdMessage: boolean = false;

    /** loginPin 欄位的錯誤訊息 */
    loginPinMessage: string = '';
    displayLoginPinMessage: boolean = false;

    /** captchaAnswer 欄位的錯誤訊息 */
    captchaAnswerMessage: string = '';
    displayCaptchaAnswerMessage: boolean = false;

    /** 登入頁數字驗證碼有效時間. */
    loginSessionPeriod: number;

    /** 登入密碼螢幕鍵盤是否啟用(暫時保留). */
    enablePinKeyboard: boolean = false;

    /** 是否關閉登入按鈕 */
    disabledLoginButton: boolean = false;

    /** 前端加密公鑰 */
    rsaKxy: string;

    /** 登入密碼操作記錄 */
    @JsonNeedPost()
    operationLog: string;

    enableE2e: string[];

}
